<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('NotAnswered')" class="mt-2">
            <pending></pending>
          </vs-tab>
          <vs-tab :label="$t('Answered')" class="mt-2">
            <answered></answered>
          </vs-tab>
          <vs-tab :label="$t('AllCriticsAndSuggestions')" class="mt-2">
            <all-suggestions></all-suggestions>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import Pending from "./Pending/Index.vue";
import Answered from "./Answered/Index.vue";
import AllSuggestions from "./AllSuggestions/Index.vue";

import "../../../assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  name: "Content_management_Rejected_Index",
  components: {
    Pending,
    Answered,
    AllSuggestions
  }
};
</script>
